










import { Vue, Component } from 'vue-property-decorator';
import TiposProductoBase from './TiposProductoBase.vue';

@Component({
  components: { TiposProductoBase },
})
export default class TiposProductoPantalla extends Vue {}
